module.exports = __webpack_public_path__ + "media/images/pictograms/pic1-3d4e487b777db131293d50869fa54129.png";